<app-title title="User Details"></app-title>
<div class="container">
  <div class="bg-white p-3 shadow-md rounded-md">
    <div class="text-gray-700">
      <div class="grid md:grid-cols-2 text-sm">
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold">First Name: </div>
          <div class="px-4 py-2">{{ userDetails?.firstName ? (userDetails?.firstName | titlecase) : 'NA' }}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold">Last Name: </div>
          <div class="px-4 py-2">{{ userDetails?.lastName  ? (userDetails?.lastName | titlecase) : 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold">Gender: </div>
          <div class="px-4 py-2">{{userDetails?.gender || 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-phone"></i>Contact No: </div>
          <div class="px-4 py-2">{{userDetails?.mobile || 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-map-marker"></i>Address: </div>
          <div class="px-4 py-2">{{userDetails?.address || 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-at"></i> Email: </div>
          <div class="px-4 py-2">
            <a class="text-blue-800 no-underline" href="mailto:{{userDetails?.email}}" target="_blank">{{userDetails?.email || 'NA'}}</a>
          </div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"> <i class="pi pi-calendar"></i>Birthday: </div>
          <div class="px-4 py-2">{{ userDetails?.dob ? (userDetails?.dob | date:'shortDate') : 'NA' }}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2"><i class="pi pi-building"></i>Organization: </div>
          <div class="px-4 py-2" *ngIf="userDetails?.organization?.name === 'PUBLIC'">{{userDetails?.orgName|| 'NA'}}</div>
          <div class="px-4 py-2" *ngIf="userDetails?.organization?.name !== 'PUBLIC'">{{userDetails?.organization?.name || 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2">GSTIN Number: </div>
          <div class="px-4 py-2">{{userDetails?.gstInNumber || 'NA'}}</div>
        </div>
        <div class="grid grid-cols-2">
          <div class="px-4 py-2 font-semibold flex items-center gap-2">Organization Name: </div>
          <div class="px-4 py-2">{{userDetails?.orgName || 'NA'}}</div>
        </div>
      </div>
      <div class="flex justify-end mt-4" >
        <p-button label="Edit" icon="pi pi-user-edit" size="small" [outlined]="true"  [routerLink]="'/settings/users/update/'+userDetails?.id"/>
      </div>
    </div>

  </div>
</div>